<template>
  <div class="yxy-header">
    <div class="yxy-header-left" @click.prevent="onClickBack">
      <a class="yxy-header-back" v-show="showBack"></a>
      <slot name="left"></slot>
    </div>
    <h1 class="yxy-header-title">
      <slot></slot>
    </h1>
    <div class="yxy-header-right">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    backMode: {
      type: String,
      default: 'route'
    },
    showBack: {
      type: Boolean,
      default: false
    },
    backPath: {
      type: [String, Object],
      default: null
    },
    enableBack: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    onClickBack () {
      if (this.backMode === 'hide') {
        this.$emit('on-hide')
      } else if (this.enableBack && this.backPath) {
        this.$router.push(this.backPath)
      } else if (this.enableBack) {
        window.history.back()
      }
    }
  }
}
</script>

<style lang="less">
@import "../../assets/yxy/variable";
@import "../../assets/weui/weui_variable";

.yxy-header {
  position: fixed;
  top: 0;
  // width: 100%;
  left: 0;
  right: 0;
  height: @headerHeight;
  z-index: 9;
  padding: 1px 0;
  box-sizing: border-box;
  background-color: @headerPrimaryBg;/*#35495E;*/
  color: #fff;
  // &:before {
  //   .setTopLine(@headerPrimaryBorderColor);
  // }
  &:after {
    .setBottomLine(@headerPrimaryBorderColor);
  }
  .yxy-header-title, h1 {
    margin: 0 60px;
    margin-left: 60px;
    text-align: center;
    height: 38px;
    line-height: 38px;
    font-size: @headerFontSize;
    font-weight: 400;
    width: auto;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: @headerPrimaryFontColor;
  }
  .yxy-header-left {
    .yxy-header-mixin();
    left: 0;
    padding-left: 18px;
    width: 38px;
    img {
      width: 100%;
      height: 100%;
    }
    a {
      position: relative;
      &:active {
        opacity: .5;
      }
    }
  }
  .yxy-header-right {
    .yxy-header-mixin();
    width: 60px;
    top: 0px;
    right: 4px;
    font-size: 16px;
    font-weight: 400;
    text-align: right;
    padding-right: 5px;
    a:active {
      opacity: .5;
    }
  }
  .yxy-header-back {
    display: inline-block;
    width: 100%;
    height: 100%;
    &:after {
      content: "";
      position: absolute;
      display: block;
      top: 10px;
      left: 0;
      width: 12px;
      height: 12px;
      border: 1px solid @headerPrimaryLeftColor;
      border-width: 1px 0 0 1px;
      margin-left: 3px;
      margin-top: 1px;
      -webkit-transform: rotate(315deg);
      transform: rotate(315deg);
    }
  }
}

.yxy-header-mixin {
  position: absolute;
  display: block;
  font-size: 14px;
  height: 38px;
  line-height: 38px;
  color: @headerPrimaryFontColor;
}
</style>
